import { Dispatch } from '@reduxjs/toolkit';
import { getAdvertisingApiCsrfToken } from 'src/commons/apis';
import { setAdvertisingApiCsrfToken } from './slice';

export const fetchAdvertisingApiCsrfToken =
  () => async (dispatch: Dispatch) => {
    const csrfToken = await getAdvertisingApiCsrfToken();
    dispatch(setAdvertisingApiCsrfToken({ csrfToken }));
  };
